import React, {Component} from "react"
import ApiService from "../../services/api"
import Loading from '../loading/loading'
import { Eye, EyeSlash } from "react-bootstrap-icons"
import M from 'materialize-css'
import configs from "../../../configs.json"

const apiservice = new ApiService()

class Login extends Component {
    constructor(props) {
        super(props)
        this.state = {
            username : "",
            password : "",
            redirect : null,
            show     : false
        }
        this.handleSubmit = this.handleSubmit.bind(this)
    }

    showErrorToast(message) {
        M.toast({ html: message, classes: 'red darken-2' })
    }

    getAuth() {
        const user  = localStorage.getItem('user')
        const token = localStorage.getItem('token')

        const req = new FormData()
        req.append('user', user)
        req.append('token', token)

        apiservice.hasAuth(req).then((res) => {
            const auth = res.auth
            switch (auth) {
                case 'Visitor':
                    this.setState({ redirect : false })
                    break
                case 'User':
                    this.setState({ redirect : true })
                    break
                case 'Client':
                    this.setState({ redirect : true })
                    break
                default:
                    this.setState({ redirect : false })
            }
        }).catch(() => {
            // Keep login page usable even when backend is offline.
            this.setState({ redirect : false })
        })
    }

    componentDidMount() {
        this.getAuth()
    }

    handleSubmit(event) {
        event.preventDefault()
        const data = new FormData()

        data.append("username", this.state.username)
        data.append("password", this.state.password)

        apiservice.login(data).then((r) => {
            localStorage.setItem('token', r.token)
            localStorage.setItem('user', this.state.username)
            this.setState({redirect: true})
        }).catch((e) => {
            if (e.response) {
                if (e.response.status === 401) {
                    this.showErrorToast("Usuario ou senha incorretos.")
                } else {
                    this.showErrorToast('Nao foi possivel fazer login agora. Tente novamente em instantes.')
                }
            } else {
                this.showErrorToast('Servico indisponivel no momento. Verifique sua conexao e tente novamente.')
            }
        })
    }

    render() {
        if (this.state.redirect === false) {
            return(
                <div className="container center" id='login'>
                    <div className="card center-align" style={{backgroundColor: configs.colors.primary}}>
                        <div className="card-title" style={{borderBottom: '1px solid ' + configs.colors.secondary}}>
                            <h4>Login</h4>
                        </div>
                        <form method="POST" encType="multipart/form-data" onSubmit={this.handleSubmit}>
                            <div className="card-content white-text">
                                <div className="center">
                                    <div className="row">
                                        <label htmlFor="input_text">Usuário</label>
                                        <input id="input_text" type="text" placeholder="User123" onChange={(e) => {this.setState({username: e.target.value})}} style={{boxShadow: '1px 1px 1px 1px ' + configs.colors.secondary}} required/>
                                    </div>
                                </div>
                                <div className="center">
                                    <div className="row">
                                        <label htmlFor="input_text">Senha</label>
                                        <input id="input_text" type={this.state.show ? "text" :"password"} placeholder="********" onChange={(e) => {this.setState({password: e.target.value})}} style={{boxShadow: '1px 1px 1px 1px ' + configs.colors.secondary}} required/>
                                        <button type="button" style={{background: 'transparent', border: 'none', cursor: 'pointer'}} onClick={() => this.setState({ show: !this.state.show })}>
                                            {this.state.show ? <Eye color="black"/> : <EyeSlash color="black"/>}
                                        </button>
                                        <a href='/recoverpassword' style={{color: configs.colors.light}}>Esqueceu a senha?</a>
                                    </div>
                                </div>
                            </div>
                            <div className="card-action" style={{borderTop: '1px solid ' + configs.colors.secondary}}>
                                <button type='submit' className="btn waves-effect waves-light hoverable" style={{backgroundColor: configs.colors.secondary}}>Entrar<i className="material-icons right">send</i></button>
                            </div>
                        </form>
                    </div>
                </div>
            )
        } 
        if (this.state.redirect === true) {
            window.location.replace(process.env.REACT_APP_URL)
        }
        if (this.state.redirect === null) {
            return (
                <Loading/>
            )
        }
    }
}

export default Login;